import { useEffect, useMemo, useState } from "react";
import type { ReactNode } from "react";
import { AuthContext } from "./AuthContext";
import type { AuthState } from "./AuthContext";
import { getClientPrincipal, hasRole, ROLE_ADMIN, ROLE_CAFETERIA, ROLE_COACH } from "./authClient";
import type { ClientPrincipal } from "./authClient";

export function AuthProvider({ children }: { children: ReactNode }) {
  const [principal, setPrincipal] = useState<ClientPrincipal | null>(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;

    void getClientPrincipal().then((p) => {
      if (cancelled) return;
      setPrincipal(p);
      setIsLoading(false);
    });

    return () => {
      cancelled = true;
    };
  }, []);

  const value = useMemo<AuthState>(
    () => ({
      principal,
      isLoading,
      isAuthenticated: principal !== null,
      isCoach: hasRole(principal, ROLE_COACH),
      isAdmin: hasRole(principal, ROLE_ADMIN),
      isCafeteria: hasRole(principal, ROLE_CAFETERIA),
    }),
    [principal, isLoading],
  );

  return <AuthContext value={value}>{children}</AuthContext>;
}
